/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminBenutzerDetailDto } from '../../models/lexplus-admin-benutzer-detail-dto';

export interface AdminBenutzerverwaltungControllerFindOneV1$Params {
  id: string;
}

export function adminBenutzerverwaltungControllerFindOneV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAdminBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAdminBenutzerDetailDto>;
    })
  );
}

adminBenutzerverwaltungControllerFindOneV1.PATH = '/v1/benutzerverwaltung/{id}';
